<script>
import { mapState } from 'vuex';
import enquire from 'enquire.js';
import SearchMachine from './SearchMachine.vue';

export default {
    name: 'SearchMachineLoader',
    components: {
        SearchMachine,
    },
    data() {
        return {
            isMobile: false,
        };
    },
    computed: {
        ...mapState('search', ['isLoading']),
    },
    mounted() {
        const self = this;
        enquire.register('screen and (max-width: 800px)', {
            match() {
                self.isMobile = true;
            },
            unmatch() {
                self.isMobile = false;
            },
        });
    },
};
</script>
